import { mapUserFromDTO } from '@entities/user/api/mappers'
import type { Employee, EmployeeDTO } from '../model/types'

export const mapEmployeeFromDTO = ({ id, user, permissions, role, is_confirmed }: EmployeeDTO): Employee => ({
    id,
    user: mapUserFromDTO(user),
    permissions,
    role,
    isConfirmed: is_confirmed
})
